import api from '@/api'

const store = {
  state: {
    dataMerchantStaff: [],
    pagingMerchantStaff: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingMerchantStaff: {
      byField: '',
      isDesc: false
    },
    filteringMerchantStaff: {
      outletCode: '',
      status: '',
      email: '',
      name: '',
      whatsApp: '',
      pinCode: ''
    }
  },

  mutations: {
    SET_MERCHANTSTAFF: (state, payload) => {
      state.dataMerchantStaff = payload
    },
    SET_PAGING_PAGE_MERCHANTSTAFF: (state, payload) => {
      state.pagingMerchantStaff.page = payload
    },
    SET_PAGING_TOTAL_MERCHANTSTAFF: (state, payload) => {
      state.pagingMerchantStaff.total = payload
    },
    SET_SORTING_MERCHANTSTAFF: (state, payload) => {
      state.sortingMerchantStaff = payload
    },
    SET_FILTERING_MERCHANTSTAFF: (state, payload) => {
      state.filteringMerchantStaff = payload
    }
  },

  getters: {
    SortingMerchantStaff: state => state.sortingMerchantStaff,
    FilteringMerchantStaff: state => state.filteringMerchantStaff,
    PagingMerchantStaff: state => state.pagingMerchantStaff,
    GetAllMerchantStaff: state => state.dataMerchantStaff,
    GetOneMerchantStaff: state => id =>
      state.dataMerchantStaff.find(
        dataMerchantStaff => dataMerchantStaff.id === id
      )
  },

  actions: {
    async UpdateSortingMerchantStaff({ commit, dispatch }, payload) {
      commit('SET_SORTING_MERCHANTSTAFF', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllMerchantStaff')
    },

    async UpdateFilteringMerchantStaff(
      { commit, dispatch, state },
      isResetField
    ) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null,
          sequence: null,
          outletCode: ''
        }
        commit('SET_FILTERING_MERCHANTSTAFF', emptyFilter)
      }
      commit('SET_PAGING_PAGE_MERCHANTSTAFF', 1)
      dispatch('GetAllMerchantStaff')
    },

    async GetAllMerchantStaff({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllMerchantStaff(
          state.pagingMerchantStaff,
          state.sortingMerchantStaff,
          state.filteringMerchantStaff
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_MERCHANTSTAFF', result.data.data)
        commit('SET_PAGING_TOTAL_MERCHANTSTAFF', result.headers['data-length'])
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateMerchantStaff({ dispatch }, payload) {
      try {
        const { data } = await api.CreateMerchantStaff(payload)
        dispatch('GetAllMerchantStaff')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateMerchantStaff({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateMerchantStaff(payload.id, payload)
        dispatch('GetAllMerchantStaff')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteMerchantStaff({ dispatch }, id) {
      try {
        const { data } = await api.DeleteMerchantStaff(id)
        dispatch('GetAllMerchantStaff')
        return data
      } catch (e) {
        throw e
      }
    }
  }
}

export default store
